<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Filtre et recherche</h3>
            <button type="button"
                    class="btn btn-xs btn-default btn-flat margin pull-right"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="resetFilter()"
            >
              Réinitialiser les filtres
            </button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <list-select-club
                  :clubsLicenciesUniquement="false"
                  title="Filtrer par club"
                  :showOptionTousLesClubs="true"
                  :clubPreSelected="clubSelectedForFilter"
                  :reset="reset"
                  @clubSelected="updateClubSelected"
                ></list-select-club>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="montantOptions">
                        Montant
                      </label>
                      <select name="montantOptions" id="montantOptions" class="pull-right form-control"
                              v-model="montantOptions">
                        <option value="0"></option>
                        <option value="1">Egal à</option>
                        <option value="2">Plus petit que</option>
                        <option value="3">Plus grand que</option>
                        <option value="4">Entre</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-show="montantOptions != 0 && montantOptions!=null"
                         :class="{ 'has-error': showErrorMontantDe }">
                      <label for="MontantDe">&nbsp;</label>
                      <div class="input-group">
                        <span class="input-group-addon">€</span>
                        <input type="text" name="montant" class="form-control" id="MontantDe"
                               v-model="montant" placeholder="">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-show="montantOptions == 4  && montantOptions!=null "
                         :class="{ 'has-error': showErrorMontantEt }">
                      <label for="MontantEt">&nbsp;</label>
                      <div style="float:left">Et</div>
                      <div class="input-group">
                        <span class="input-group-addon">€</span>
                        <input type="text" name="montant_limite" id="MontantEt" v-model="montantLimite"
                               class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 input-daterange" id="dataRange1">
                <div class="form-group">
                  <label>Du:</label>
                  <div class="input-group date ">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="periodeDu" v-model="periodeDu"
                           class="form-control pull-right datepicker" id="datepicker1">
                  </div>
                  <!-- /.input group -->
                </div>
                <div class="form-group ">
                  <label>Au:</label>
                  <div class="input-group date ">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="periodeAu" v-model="periodeAu"
                           class="form-control pull-right datepicker" id="datepicker2">
                  </div>
                  <!-- /.input group -->
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group" style="float: left;">
                  <label for="montantOptions">
                    Statut
                  </label>

                  <select name="montantOptions" id="statut" class="pull-right form-control"
                          v-model="statutRecherche">
                    <option value="0"></option>
                    <option
                      v-for="statut in getStatusRecap"
                      :value="statut.id"
                    > {{ statut.type }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="montantOptions">
                    Créé via MyABFT
                  </label>

                  <select name="montantOptions" id="generate_by_myabft" class="pull-right form-control"
                          v-model="generate_by_myabft">
                    <!--                    <option value="0">NON</option>-->
                    <!--                    <option value="1">OUI</option>-->
                    <!--                    <option value="2">Pas d'importance</option>-->
                  </select>
                </div>
              </div>

            </div>
          </div>
          <div class="box-footer">
            <input type="submit" @click.prevent="searchRecaps()" value="Rechercher" class="btn btn-primary pull-right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border entete-listing">
            <h3 class="box-title">Listing des récapitulatifs: {{ pagination_meta.total }} résultat{{ pagination_meta.total > 1 ? 's' : '' }}</h3>

            <div class="entete-actions">
              <b-form-input v-model="filter" class="champ-recherche" placeholder="Rechercher..."></b-form-input>

              <span class="text-muted" v-if="recapsSelectionnes.length">
                {{ recapsSelectionnes.length }} sélectionné{{ recapsSelectionnes.length > 1 ? 's' : '' }}
                (toutes pages)
              </span>

              <div class="btn-group">
                <button @click.prevent="selectAll()" type="button" class="btn btn-default">Sélectionner la page
                </button>
                <button
                        type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                  <span class="caret"></span>
                  <span class="sr-only">Dropdown</span>
                </button>
                <ul class="dropdown-menu" role="menu">
                  <li><a @click.prevent="selectAll()">Sélectionner la page</a></li>
                  <li><a @click.prevent="deselectAll()">Déselectionner la page</a></li>
                  <li><a @click.prevent="deselectAllPages()">Tout déselectionner ({{ recapsSelectionnes.length }})</a></li>
                </ul>
              </div>

              <button @click.prevent="exportCSV()" type="button" class="btn btn-default"
                      :disabled="recapsSelectionnes.length === 0">
                Exporter en XLS/CSV (Excel)
              </button>
              <button @click.prevent="exporterExpertM()" type="button" class="btn btn-primary"
                      :disabled="exportExpertMEnCours || recapsSelectionnes.length === 0">
                <i class="fa" :class="exportExpertMEnCours ? 'fa-spinner fa-spin' : 'fa-file-code-o'"></i>
                Exporter vers Expert/M (XML)
              </button>
            </div>
          </div>
          <div class="box-body">
            <div class="selection-plage">
              <span>Sélectionner les récapitulatifs du n°</span>
              <input type="number" class="form-control" v-model.number="plageDu"
                     min="1" placeholder="9800" @keyup.enter="selectionnerPlage()">
              <span>au n°</span>
              <input type="number" class="form-control" v-model.number="plageAu"
                     min="1" placeholder="9900" @keyup.enter="selectionnerPlage()">
              <button type="button" class="btn btn-default" @click.prevent="selectionnerPlage()">
                Ajouter à la sélection
              </button>
              <span class="text-muted">Les numéros inexistants sont ignorés.</span>
            </div>

            <div class="alert alert-warning" v-if="rapportExportExpertM">
              <button type="button" class="close" @click="rapportExportExpertM = null">&times;</button>
              <p><strong>{{ rapportExportExpertM.message }}</strong></p>
              <table class="table table-condensed"
                     v-if="rapportExportExpertM.ecartes && rapportExportExpertM.ecartes.length">
                <thead>
                  <tr>
                    <th>Récapitulatif</th>
                    <th>N° comptable</th>
                    <th>Club</th>
                    <th>Date</th>
                    <th>Motif</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ecarte in rapportExportExpertM.ecartes" :key="ecarte.id">
                    <td>{{ ecarte.id }}</td>
                    <td>{{ ecarte.numero_comptable || '-' }}</td>
                    <td>{{ ecarte.numero_club || '-' }}</td>
                    <td>{{ ecarte.date }}</td>
                    <td>{{ ecarte.explication }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-table
              id="tableListingAllRecaps"
              v-if="!loadingListingRecap && listingRecaps.length>0"
              responsive bordered striped hover
              :items="listingRecaps"
              :filter="filter"
              :fields="columnsListingRecap"
              :per-page="pagination_meta.per_page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :empty-text="'Aucun résultat'"
              :empty-filtered-text="'Aucun résultat'"
              foot-clone
              show-empty
              ref="table"
              @filtered="onListingFiltered"
            >
              <template slot="select" slot-scope="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @change="majSelection(row.item.id, $event)"
                ></b-form-checkbox>
              </template>
              <template slot="actions" slot-scope="row">
                <router-link
                  class="btn btn-default padding2"
                  :to="{ name: 'Recap', params: { recap_id: row.item.id }}">
                  <i class="glyphicon glyphicon-pencil"></i>
                </router-link>
              </template>
              <template slot="id" slot-scope="row">
                <router-link
                  :to="{ name: 'Recap', params: { recap_id: row.item.id }}">
                  <span v-if="row.item.generate_by_myabft">MyABFT - </span>
                  Récapitulatif {{ row.item.id | idFormat }}

                </router-link>
              </template>
              <template slot="statut" slot-scope="data">
                                <span
                                  :class="getClassNameRecap(data.item.statut)">
                                    {{ data.item.statut }}
                                </span>
              </template>
              <template slot="nombre_licence" slot-scope="data">
                {{ data.item.nombre_licence }}{{ data.item.nombre_licence > 1 ? " membres" : " membre" }}
              </template>
              <template slot="total" slot-scope="data">
                {{ data.item.total | idFormat }}€
              </template>

              <template slot="order" slot-scope="data">
                <router-link
                  v-if="data.item.order"
                  :to="{ name: 'Liste_commandes_myabft', params: { order_id: data.item.order}}">
                  Bon de commande n°{{ data.item.order | idFormat }}
                </router-link>
                <span v-if="!data.item.order">-</span>
              </template>
              <template slot="club" slot-scope="data">
                <router-link
                  :to="{ name: 'Club', params: { club_id: data.item.id_club }}">
                  N°{{ data.item.num_club }} - {{ data.item.club }}
                </router-link>
              </template>
            </b-table>

            <div style="display:inline-block" class="margin-r-5">
              <span style="display:inline-block">Par Page:</span>
              <select class="form-control" v-model="pagination_meta.per_page"
                      @change="changePerPage"
                      style="display:inline-block;width: 100px;">
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="75">75</option>
                <option :value="100">100</option>
                <option :value="200">200</option>
                <option :value="500">500</option>
              </select>
            </div>

            <b-pagination size="md"
                          class="pull-right"
                          @change="changePage"
                          :total-rows="pagination_meta.total"
                          v-model="pagination_meta.current_page"
                          :per-page="pagination_meta.per_page">
            </b-pagination>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'
import ListSelectClub from '../../Communs/listeSelectClub'
import '../../../utils'
import FileSaver from "file-saver";
// require('../../../../node_modules/')
require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

var _ = require('underscore')
var moment = require('moment')

export default {
  props: {
    clubPreSelected: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      clubSelectedForFilter: -1,
      sortBy: null,
      sortDesc: null,
      filter: null,
      listingRecaps: [],
      // Ids sélectionnés, toutes pages confondues : le listing est rechargé à
      // chaque page et perdrait sinon les cases cochées précédemment
      recapsSelectionnes: [],
      plageDu: null,
      plageAu: null,
      exportExpertMEnCours: false,
      rapportExportExpertM: null,
      loadingListingRecap: true,
      isBusy: false,
      current_page: 1,
      periodeDu: null,
      periodeAu: null,
      montant: null,
      statutRecherche: 0,
      montantLimite: null,
      montantOptions: null,
      reset: false,
      showErrorMontantEt: false,
      showErrorMontantDe: false,
      generate_by_myabft: 2,
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 100,
        to: 1,
        total: 1
      },
      columnsListingRecap: [
        {
          label:"Sélection",
          key:"select",
          sortable:false,
        },
        {
          label: 'Date',
          key: 'date',
          sortable: true,
        },
        {
          label: 'Numéro',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Numéro Comptable',
          key: 'numero_comptable',
          sortable: true,
        },
        {
          label: 'Club',
          key: 'club',
          sortable: true,
        },
        {
          label: 'Nombre de licences',
          key: 'nombre_licence',
          sortable: false,
        },
        {
          label: 'Bon de commande lié',
          key: 'order',
          sortable: true,
        },
        {
          label: 'Statut',
          key: 'statut',
          sortable: true,
        },
        {
          label: 'Total',
          key: 'total',
          sortable: false,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getStatusRecap: 'getStatusRecap',
    }),
    // recapsSelected() {
    //   return this.listingRecaps.filter(recap => recap.selected).map(recap => recap.id)
    // },
  },
  mounted: function () {
    var these = this
    if (this.clubPreSelected > 0)
      this.clubSelectedForFilter = this.clubPreSelected

    this.getTableListingRecap();
    this.$nextTick(() => {
      $('.input-daterange input').each(function () {
        // console.log($(this))
        $(this).datepicker({
          autoclose: true,
          language: 'fr',
        }).on("changeDate", (e) => {
          // console.log(e.date)
          if ($(this)[0].id == 'datepicker1')
            these.periodeDu = moment(e.date).format('DD/MM/YYYY')
          if ($(this)[0].id == 'datepicker2')
            these.periodeAu = moment(e.date).format('DD/MM/YYYY')
        });
      });

    })
  },
  created() {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadStatutsRecaps()
    })
  },
  watch: {
    'listingRecaps': function (val) {
      console.log(val)
    },
    'montant': function (val) {
      this.constructSearchRequest()
    },
    'sortBy': function (val) {
      this.getTableListingRecap()
    },
    'sortDesc': function (val) {
      this.getTableListingRecap()
    },
    'montantLimite': function (val) {
      this.constructSearchRequest()
    },
    'montantOptions': function (val) {
      if (val == 0) {
        this.montant = null
        this.montantLimite = null
      }
      this.constructSearchRequest()
    },
    'periodeDu': function (val) {
      if (moment(this.periodeAu, "DD/MM/YYYY").isBefore(moment(this.periodeDu, "DD/MM/YYYY")) ||
        !moment(this.periodeAu, "DD/MM/YYYY").isValid())
        this.periodeAu = this.periodeDu
      this.constructSearchRequest()
    },
    'periodeAu': function (val) {
      this.constructSearchRequest()
    },
    'clubSelectedForFilter': function (val) {
      this.constructSearchRequest()
    },
    'clubPreSelected': function (val) {
      this.clubSelectedForFilter = val
    },

  },
  components: {
    vSelect,
    ListSelectClub,
  },
  methods: {
    // Le serveur renvoie ses erreurs en JSON, mais la réponse est lue en blob
    lireErreurJson: function (response) {
      return new Promise(function (resolve) {
        if (!response.body || typeof response.body.text !== 'function')
          return resolve(response.body || {})
        response.body.text().then(function (texte) {
          try {
            resolve(JSON.parse(texte))
          } catch (e) {
            resolve({})
          }
        }, function () {
          resolve({})
        })
      })
    },
    exporterExpertM: function () {
      this.rapportExportExpertM = null
      let nombre = this.recapsSelectionnes.length
      if (nombre === 0) return

      // Exporter plusieurs centaines de lignes ne doit pas tenir en un seul clic
      // « numéros » et non « récapitulatifs » : une plage peut contenir des numéros inexistants
      let question = 'Exporter la sélection vers Expert/M (' + nombre + ' numéro'
        + (nombre > 1 ? 's' : '') + ') ?\n\n'
        + 'Le serveur ignorera les numéros inexistants, et écartera les récapitulatifs annulés,'
        + ' sans numéro comptable ou sans licence facturable.'
      if (!confirm(question)) return

      this.exportExpertMEnCours = true
      this.lancerExportExpertM()
    },
    lancerExportExpertM: function () {
      let these = this
      this.$http.post(this.getRoute('Secretariat.exportRecapsExpertM'), {
        ids: this.recapsSelectionnes,
      }, {responseType: 'blob'})
        .then(function (response) {
          // Le serveur renvoie une archive contenant le XML et le rapport JSON
          let blob = new Blob([response.body], {type: 'application/zip'})
          // Le nom du serveur n'est pas lisible tant que Content-Disposition n'est pas exposé
          // par le CORS : à défaut, un nom horodaté, comme celui du serveur
          let nomDeSecours = 'export-expertm-' + moment().format('YYYYMMDD-HHmmss') + '.zip'
          FileSaver.saveAs(blob, these.nomFichierDepuisReponse(response, nomDeSecours))
          these.$noty.success('Export généré : le XML et le rapport des écartés sont dans l\'archive')
          these.exportExpertMEnCours = false
          these.getTableListingRecap()
        }, function (response) {
          these.lireErreurJson(response).then(function (corps) {
            if (corps && corps.message) {
              // 422 : rien à exporter, ou trop de récapitulatifs pour un seul fichier
              these.rapportExportExpertM = corps
              these.$noty.error(corps.message)
            } else {
              these.$noty.error('Erreur lors de l\'export vers Expert/M')
            }
            these.exportExpertMEnCours = false
          })
        })
    },
    ...mapActions({
      setStatusRecap: 'setStatusRecap',
    }),
    // Une plage de numéros coche les lignes correspondantes : l'export reste piloté
    // par la sélection, et le serveur ignore les numéros qui n'existent pas
    selectionnerPlage: function () {
      let du = parseInt(this.plageDu, 10)
      let au = parseInt(this.plageAu, 10)

      if (!du || !au || du < 1 || au < 1) {
        this.$noty.error('Indiquez le premier et le dernier numéro de la plage')
        return
      }
      if (du > au) {
        this.$noty.error('Le premier numéro doit être inférieur ou égal au dernier')
        return
      }
      // Garde-fou technique sur la taille de la requête, sans rapport avec le
      // plafond par fichier, que seul le serveur connaît
      if (au - du + 1 > 2000) {
        this.$noty.error('Plage trop large (' + (au - du + 1) + ' numéros) : restreignez-la')
        return
      }

      let ajoutes = 0
      for (let id = du; id <= au; id++) {
        if (this.recapsSelectionnes.indexOf(id) === -1) {
          this.recapsSelectionnes.push(id)
          ajoutes++
        }
      }
      this.listingRecaps.forEach(item => {
        item.selected = this.recapsSelectionnes.indexOf(item.id) !== -1
      })
      this.$refs.table.refresh()
      this.$noty.success(ajoutes + ' numéro' + (ajoutes > 1 ? 's ajoutés' : ' ajouté') + ' à la sélection')
    },
    majSelection: function (id, selectionne) {
      let index = this.recapsSelectionnes.indexOf(id)
      if (selectionne && index === -1)
        this.recapsSelectionnes.push(id)
      else if (!selectionne && index !== -1)
        this.recapsSelectionnes.splice(index, 1)
    },
    selectAll: function () {
      let these = this
      this.listingRecaps.forEach(function (item) {
        item.selected = true
        these.majSelection(item.id, true)
      })
      this.$refs.table.refresh()

    },
    deselectAll: function () {
      let these = this
      this.listingRecaps.forEach(function (item) {
        item.selected = false
        these.majSelection(item.id, false)
      })
      this.$refs.table.refresh()
    },
    deselectAllPages: function () {
      this.recapsSelectionnes = []
      this.listingRecaps.forEach(function (item) {
        item.selected = false
      })
      this.$refs.table.refresh()
    },
    recapsSelected() {
      return this.recapsSelectionnes
    },
    exportCSV: function () {
      console.log(this.recapsSelected())
      if (this.recapsSelected().length <= 0)
        return;
      let these = this;
      this.loadingListingRecap = true
      this.$http.post(this.getRoute('Secretariat.exportRecapsEvaOnline'), JSON.stringify({recaps: this.recapsSelected()}), {responseType: 'blob'})
        .then(function (response) {
          // Un .xlsx n'est pas un application/vnd.ms-excel : Excel proteste à l'ouverture
          var blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          FileSaver.saveAs(blob, these.nomFichierDepuisReponse(response, 'ListingRecapEvaOnline.xlsx'));
          these.loadingListingRecap = false
          return response.blob();
        }, (response) => {
          these.$noty.error("Erreur dans la génération de l'export")
          these.loadingListingRecap = false
        });
    },
    // Le nom envoyé par le serveur fait foi ; l'en-tête n'est lisible que s'il est
    // exposé par le CORS, d'où le repli sur le nom connu du fichier
    nomFichierDepuisReponse: function (response, nomParDefaut) {
      let entete = response.headers ? response.headers.get('Content-Disposition') : null
      if (entete) {
        let correspondance = /filename[^;=\n]*=(?:UTF-8''|")?([^";\n]*)/i.exec(entete)
        if (correspondance && correspondance[1])
          return decodeURIComponent(correspondance[1].trim())
      }
      return nomParDefaut
    },
    getClassNameRecap: function (statut) {
      return this.$getClassNameRecap(statut)
    },
    onListingFiltered(filteredItems) {
      if (this.filter != "") {
        this.pagination_meta.total = filteredItems.length
        this.pagination_meta.currentPage = 1
      } else {
        this.getTableListingRecap();
      }
    },

    searchRecaps: function () {
      this.sortDesc = null;
      this.sortBy = null;
      this.getTableListingRecap();
    },
    resetFilter: function () {
      this.clubSelectedForFilter = null;
      this.periodeDu = null;
      this.periodeAu = null;
      this.montant = null;
      this.montantLimite = null;
      this.montantOptions = null;
      this.showErrorMontantEt = false;
      this.showErrorMontantDe = false;
      this.reset = !this.reset;
    },
    constructSearchRequest: function () {
      var objectTemp = {}
      if (this.montant != '' && this.montant != null)
        objectTemp.montant = this.montant
      if (this.montantOptions != '' && this.montantOptions != null)
        objectTemp.montantOptions = this.montantOptions
      if (this.montantLimite != '' && this.montantLimite != null)
        objectTemp.montant_limite = this.montantLimite
      if (this.periodeDu != '' && this.periodeDu != null)
        objectTemp.periodeDu = this.periodeDu
      if (this.periodeAu != '' && this.periodeAu != null)
        objectTemp.periodeAu = this.periodeAu
      if (this.clubSelectedForFilter != '' && this.clubSelectedForFilter > 0 && this.clubSelectedForFilter != null)
        objectTemp.clubSelectedForFilter = this.clubSelectedForFilter

      if (this.statutRecherche != 0 && this.statutRecherche != null)
        objectTemp.statut = this.statutRecherche
      if (this.generate_by_myabft != 2 && this.generate_by_myabft != null)
        objectTemp.generate_by_myabft = this.generate_by_myabft

      if (this.pagination_meta.per_page != 0 && this.pagination_meta.per_page != null)
        objectTemp.per_page = this.pagination_meta.per_page
      if (this.sortBy != null) {
        let sortDesc = this.sortDesc != null ? this.sortDesc == true ? "asc" : "desc" : "desc"
        objectTemp.sort = this.sortBy + "|" + sortDesc
      }
      if (this.pagination_meta.current_page != 0 && this.pagination_meta.current_page != null)
        objectTemp.currentPage = this.pagination_meta.current_page

      return (objectTemp);
    },
    changePage: function (e) {
      this.pagination_meta.current_page = e
      this.getTableListingRecap();
    },
    changePerPage: function (e) {
      this.pagination_meta.per_page = e.target.value
      this.constructSearchRequest()
      this.getTableListingRecap();
    },
    updateClubSelected: function (value) {
      this.clubSelectedForFilter = value.id;
    },
    currentYear: function () {
      return moment().year();
    },
    getTableListingRecap: function () {
      this.loadingListingRecap = true;
      this.isBusy = true
      let self = this
      // debugger;
      this.$http.post(self.getRoute('Secretariat.recapitulatif.getAll'), this.constructSearchRequest())
        .then((response) => {
          self.listingRecaps = response.body.data
          // Restaurer les cases cochées sur les pages déjà parcourues
          self.listingRecaps.map(function (item) {
            item.selected = self.recapsSelectionnes.indexOf(item.id) !== -1
          })
          self.pagination_meta = response.body.meta
          self.loadingListingRecap = false;
          self.$root.$emit('bv::refresh::table', 'tableListingAllRecaps');
        }, (response) => {
          self.listingRecaps = []
          self.$root.$emit('bv::refresh::table', 'tableListingAllRecaps');
        });
    },
    isTableListingRecapLoading: function (force = false) {
      if (force)
        return true
      return this.loadingListingRecap;
    },
    console: function (event) {
      console.log(event);
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    loadStatutsRecaps: function () {
      this.$http.get(this.getRoute('getAllStatutsRecaps')).then((response) => {
        this.setStatusRecap(response.body)
      }, (response) => {
      });
    },
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>

<style scoped>
/* Une seule rangée d'actions, qui passe à la ligne proprement au lieu
   d'empiler des pull-right dans un ordre visuel inversé */
.entete-listing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

/* Le titre garde le bord gauche, même seul sur sa ligne en écran étroit */
.entete-listing .box-title {
  margin-right: auto;
}

.entete-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
}

.entete-actions .champ-recherche {
  width: 180px;
  height: 34px;
}

.selection-plage {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.selection-plage .form-control {
  width: 110px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Secretariat/Recapitulatif/ListingRecap.vue